
import Vue from "vue";
import { Translation } from "@/utils/translation";
import AppLabel from "@/components/InfoInput.vue";
export default Vue.extend({
	props: {
		value: {
			type: Object as ()=>Translation,
			required: true
		}
	},
	components: {
		AppLabel
	}
});
